<template>
  <div class="otherauth">
    <plat-icon-slide></plat-icon-slide>

    <div class="platform_list">
      <div v-if="chosen_tab == 'other'">
        <div
          class="platform_item"
          :class="`platform_item_${index}`"
          :id="`platform_item_${index}`"
          v-for="(item, index) in platform_banners"
          :key="index"
        >
          <div class="platfrom_banner">
            <img :src="item.banner" alt />
          </div>
          <div class="platform_introduce">
            <div class="platform_conatiner">
              <img :src="item.introduce" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

// comp
import PlatIconSlide from "./PlatIconSlide";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["chosen_tab", "show_nine"]),
    platform_banners: function () {
      let arr = [
        {
          banner: require("../img/tencent-banner.png"),
          name: "腾讯视频",
          introduce: require("../img/tencent-intro.png"),
        },
        {
          banner: require("../img/qqmusic-banner.png"),
          name: "QQ音乐",
          introduce: require("../img/qqmusic-intro.png"),
        },
        {
          banner: require("../img/youku-banner.png"),
          name: "优酷",
          introduce: require("../img/youku-intro.png"),
        },
        {
          banner: require("../img/kugou-banner.png"),
          name: "酷狗音乐",
          introduce: require("../img/kugou-intro.png"),
        },
        {
          banner: require("../img/wangyimusic-banner.png"),
          name: "网易云音乐",
          introduce: require("../img/wangyimusic-intro.png"),
        },
        {
          banner: require("../img/qingting-banner.png"),
          name: "蜻蜓FM",
          introduce: require("../img/qingting-intro.png"),
        },
        {
          banner: require("../img/baidu-banner.png"),
          name: "百度网盘",
          introduce: require("../img/baidu-intro.png"),
        },
        {
          banner: require("../img/lanren-banner.png"),
          name: "懒人听书",
          introduce: require("../img/lanre-intro.png"),
        },
        {
          banner: require("../img/kfc-banner.png"),
          name: "肯德基",
          introduce: require("../img/kfc-intro.png"),
        }
      ];

      if (!this.show_nine) {
        arr.push({
          banner: require("../img/qq-member-banner.png"),
          name: "QQ超级会员",
          introduce: require("../img/qq-member-intro.png"),
        });
      }
      return arr;
    },
  },
  components: {
    PlatIconSlide,
  },
};
</script>

<style lang="scss" scoped>
@import "../css/common.scss";
.otherauth {
  padding-bottom: trans(38);
}

.platform_list {
  margin-top: trans(8);
  .platform_item {
    @include boxsize(710, 500);
    margin-bottom: trans(33);
    .platfrom_banner {
      @include boxsize(710, 189);
      img {
        width: 100%;
        display: block;
      }
    }
    .platform_introduce {
      @include boxsize(710, 311);
      @include bgimg("../img/platform_bg.png", 100%, 100%);
      .platform_conatiner {
        @include boxsize(710, 311);
        @include layout(space-between, center);
        margin: 0 auto;
        img {
          width: 100%;
          display: block;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/OtherAuth.vue